import accordionEvents from './accordion';
import storeCreditEvents from './storeCredits';
import checkoutGenericEvents from './checkoutUtils';
import './index.scss';
jQuery(function ($) {
    checkoutGenericEvents();
    accordionEvents();
    storeCreditEvents();
});
